/* global Site, I18n */

/**
 * composables -kansiossa olevat tiedostot on tarkoituksella pilkottu päätiedostoista (search.js, services.js etc.)
 * Tämä johtuu siitä, että näissä tiedostoissa olevia datoja tai funktioita käytetään tismalleen samanlaisena eri
 * komponenteissa, jos niihin jostain syystä tarvitsee tehdä muutoksia, ei niitä tarvitse muistaa tehdä useaan paikkaan
 *
 * Vuen mukaan composablejen prefixinä tulisi käyttää use-sanaa (useFunktionNimi)
 *
 * Pagingiin liittyvät funktiot
 */

/**
 * Palauttaa sivun ensimmäisen postin indexin
 * @param {string} selector Selectorin nimi
 * @returns {number} Nykyinen sivu kertaa postien määrä per sivu (sivu 3 * posteja 10 = index 30)
 */
export function usePageStart(selector = 'usePaginationData') {
	return (this[selector].page - 1) * this[selector].postsPerPage;
}

/**
 * Palauttaa sivun viimeisen postin indexin
 * @param {string} postType Post type, käytetään tulosten maksimimäärän määrittämiseen
 * @param {string} selector Selectorin nimi
 * @returns {number} Tulosten määrä jos index on suurempi kuin se, muuten seuraava sivu kertaa postien määrä per sivu
 */
export function usePageEnd(postType, selector = 'usePaginationData') {
	const endPage = this[selector].page * this[selector].postsPerPage;

	if (endPage > this.results[postType].count) {
		return this.results[postType].count;
	}

	return endPage;
}

/**
 * Sivun vaihtamisen funktio
 */
export function useChangePage() {
	const targetSelector = '.results';
	const element = document.querySelector(targetSelector);

	if (!element) {
		return;
	}

	const elementPos = element.getBoundingClientRect().top;
	const offset = 150;
	const scrollPos = elementPos + window.pageYOffset - offset;

	window.scrollTo({
		top: scrollPos,
		behavior: 'smooth',
	});
}

/**
 * Sivujen määrä
 * @param {number} count Tulosten määrä
 * @param {string} selector Selectorin nimi
 * @returns {number} Sivujen määrä (tulosten määrä / postien määrä per sivu)
 */
export function usePages(count, selector = 'usePaginationData') {
	return Math.ceil(count / this[selector].postsPerPage);
}

/**
 * Paginationin dataobjekti
 */
export const usePaginationData = {
	count: 0,
	page: 1,
	postsPerPage: 3,
	pagination: {
		prev: I18n.previous,
		next: I18n.next,
	},
};
